module.exports = __webpack_public_path__ + "static/media/addnewbank.7c64dc35.svg";